
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'AsyncTooltip'
})
export default class AsyncTooltip extends Vue {
  // 必须：返回 Promise<string> 的接口函数
  @Prop({ required: true }) private request!: () => Promise<string>;
  
  // 可选：缓存数据，避免重复请求
  @Prop({ default: true }) private cache!: boolean;
  
  @Prop({ default: 'top' }) private placement!: string;
  
  @Prop({ default: 'dark' }) private effect!: string;

  // 新增：是否禁用
  @Prop({ default: false }) private disabled!: boolean;

  private showTooltip = false;
  private tooltipContent = '加载中...'; // 初始内容或加载状态
  private hasLoaded = false;
  private loading = false;

  private async handleMouseEnter() {
    if (this.disabled) return; // 如果被禁用，直接忽略

    // 如果开启缓存且已经加载过，直接显示
    if (this.cache && this.hasLoaded) {
      if (this.tooltipContent) { // 只有内容不为空才显示
         this.showTooltip = true;
      }
      return;
    }

    // 如果正在请求中，不重复触发
    if (this.loading) return;

    try {
      this.loading = true;
      // 可选：在这里先显示 tooltip 展示 "加载中..."
      this.showTooltip = true;

      // 调用父组件传递的接口方法
      const content = await this.request();
      // 这里做类型判断，主要还是因为如果后端返回了非字符串类型的数据，会展示成json类型数据。
      if (!content || typeof content !== 'string') {
        // 如果内容为空，标记为已加载（避免重复请求），但不显示
        this.hasLoaded = true;
        this.tooltipContent = '';
        this.showTooltip = false;
        return;
      }

      this.tooltipContent = content;
      this.hasLoaded = true;

      // 数据回来后，展示 Tooltip
      this.showTooltip = true;
    } catch (error) {
      console.error('Tooltip content load failed', error);
      this.tooltipContent = '加载失败';
      this.showTooltip = true;
    } finally {
      this.loading = false;
    }
  }

  private handleMouseLeave() {
    this.showTooltip = false;
  }
}
